module.exports = __webpack_public_path__ + "img/ATTACHMENT.f9764da3.svg";